<template>
  <vuestic-widget :headerText="$t(title)">
    <table class="table first-td-padding object-table">
      <tbody>
        <tr>
          <td width="25%"></td>
          <td width="75%"></td>
        </tr>
        <tr v-for="(field, fieldName) in object.manifest" v-if="object !== undefined">
        <!-- Property -->
          <td class="key">{{ field.title }}</td>
        <!-- Value -->
          <!-- Date -->
          <td v-if="field.type === 'date'">{{ object[fieldName] | formatDate }}</td>
          <!-- Link -->
          <td v-else-if="field.type === 'link'">
            <router-link :key="fieldName" :to="{ name: field.path, params: { id: object[field.id] || $route.params.id }}">
              {{ field.title }}
            </router-link>
          </td>
          <!-- Hyperlink -->
          <td v-else-if="field.type === 'hyperlink'">
            <a :href="object[fieldName]">{{ field.title }}</a>
          </td>
          <!-- Password -->
          <td v-else-if="field.type === 'password'">
            *********
          </td>
          <!-- String / Text -->
          <td v-else>{{ object[fieldName] }}</td>
        </tr>
      </tbody>
    </table>
    <div class="row actions">
      <div class="col-md-6 offset-md-6 text-right">
        <button class="btn btn-danger btn-sm" @click="destroy()" v-if="object.can('remove')">
          <div class="btn-with-icon-content">
            <i class="ion-md-close ion"></i>
            Delete
          </div>
        </button>
        <button class="btn btn-success btn-sm" @click="edit()" v-if="object.can('edit')">
          Edit
        </button>
      </div>
    </div>
  </vuestic-widget>
</template>

<script>
  export default {
    name: 'mc-show',
    props: {
      title: String,
      object: Object
    },
    methods: {
      edit () {
        this.$emit('edit')
      },
      destroy () {
        this.$emit('delete')
      }
    }
  }
</script>

<style>
  td.key {
  text-transform: uppercase;
  font-weight: 500;
  }

  .object-table th, .object-table td {
  min-width: 120px;
  padding: 10px 20px;
  }

  .form-group1 {
    margin: 0 0 0 0;
  }

  .form-group1 input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .row.actions {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/Show.vue